import { GroupState } from '@/composition/groups'
import { LearningState } from '@/composition/learning'
import { MemberStatus } from '@/models/Groups'
import { useAppStore } from '@/store/app'
import { AxiosError } from 'axios'
import AnalyticsServiceCls from './AnalyticsService'
import ChannelsServiceCls from './ChannelsService'
import CommentsServiceCls from './CommentsService'
import ContentReportServiceCls from './ContentReportService'
import ConversationsServiceCls from './ConversationsService'
import CoursesServiceCls from './CoursesService'
import EventsRSVPServiceCls from './EventsRSVPService'
import EventsServiceCls from './EventsService'
import FormsServiceCls from './FormsService'
import GiphyServieCls from './GiphyService'
import GroupsServiceCls from './GroupsService'
import ImportServiceCls from './ImportService'
import InvitationsServiceCls from './InvitationService'
import ListingsServiceCls from './ListingsService'
import MarketplaceGroupsServiceCls from './MarketplaceGroupsService'
import MediaServiceCls from './MediaService'
import PostsServiceCls from './PostsService'
import ReactionsServiceCls from './ReactionsService'
import SearchServiceCls from './searchService'
import SocketServiceCls from './SocketsService'
import UsersServiceCls from './UsersService'

let GroupsService: GroupsServiceCls
let MarketplaceGroupsService: MarketplaceGroupsServiceCls
let ConversationsService: ConversationsServiceCls
let MediaService: MediaServiceCls
let GiphyService: GiphyServieCls
let PostsService: PostsServiceCls
let ChannelsService: ChannelsServiceCls
let UsersService: UsersServiceCls
let CommentsService: CommentsServiceCls
let ReactionsService: ReactionsServiceCls
let InvitationsService: InvitationsServiceCls
let CoursesService: CoursesServiceCls
let FormsService: FormsServiceCls
let ContentReportService: ContentReportServiceCls
let EventsService: EventsServiceCls
let EventsRSVPService: EventsRSVPServiceCls
let SocketService: SocketServiceCls
let SearchService: SearchServiceCls
let AnalyticsService: AnalyticsServiceCls
let ListingsService: ListingsServiceCls
let ImportService: ImportServiceCls

export function initializeService(locationId: string) {
  MarketplaceGroupsService = new MarketplaceGroupsServiceCls()
  GroupsService = new GroupsServiceCls(locationId)
  ConversationsService = new ConversationsServiceCls(locationId)
  SocketService = new SocketServiceCls(locationId)
  ListingsService = new ListingsServiceCls()
  AnalyticsService = new AnalyticsServiceCls()
}

export async function initializeGroup(groupSlug: string): Promise<void> {
  try {
    const appStore = useAppStore()
    let locationId = appStore.$state.locationId
    await GroupState.getGroupBySlug(groupSlug)
    locationId = GroupState.state.groupData.locationId
    if (GroupState.state?.userGroup) {
      appStore.setUserId(GroupState.state.userGroup.contactId)
    }
    appStore.setLocationId(locationId)
    GroupsService = new GroupsServiceCls(locationId)
    const groupId = GroupState.state.groupData._id
    CoursesService = new CoursesServiceCls(locationId, groupId)
    UsersService = new UsersServiceCls(locationId, groupId)
    FormsService = new FormsServiceCls(locationId, groupId)
    MediaService = new MediaServiceCls(locationId, groupId)
    GiphyService = new GiphyServieCls()
    PostsService = new PostsServiceCls(locationId, groupId)
    ChannelsService = new ChannelsServiceCls(locationId, groupId)
    CommentsService = new CommentsServiceCls(locationId, groupId)
    ReactionsService = new ReactionsServiceCls(locationId, groupId)
    InvitationsService = new InvitationsServiceCls(locationId, groupId)
    ContentReportService = new ContentReportServiceCls(locationId)
    SearchService = new SearchServiceCls(locationId, groupId)
    EventsService = new EventsServiceCls(locationId, groupId)
    EventsRSVPService = new EventsRSVPServiceCls(locationId, groupId)

    ImportService = new ImportServiceCls(locationId, groupId)

    if (
      GroupState.state.groupData?.settings?.groupType != 'Private' ||
      (GroupState.state.role &&
        GroupState.state?.userStatus === MemberStatus.ACTIVE)
    ) {
      GroupState.getGroupAdmins()
      GroupState.fetchGroupMembers()
      LearningState.initializeLearningState()
    }

    // GroupState.getGroupAdmins()
    // GroupState.fetchGroupMembers()
    appStore.setGroupId(groupId)
  } catch (error) {
    if (!(error instanceof AxiosError && error.response?.status === 404)) {
      console.error(error)
    }
    throw error
  }
}
export {
  AnalyticsService,
  ChannelsService,
  CommentsService,
  ContentReportService,
  ConversationsService,
  CoursesService,
  EventsRSVPService,
  EventsService,
  FormsService,
  GiphyService,
  GroupsService,
  ImportService,
  InvitationsService,
  ListingsService,
  MarketplaceGroupsService,
  MediaService,
  PostsService,
  ReactionsService,
  SearchService,
  SocketService,
  UsersService,
}
